import { z } from 'zod';

type T = (key: string) => string;

// Description is optional. When provided it must clear the 10-char floor so
// a one-word placeholder doesn't pollute the embedding; blank values pass
// straight through (backend rebuilds the embedding from name + form labels
// + custom field names in that case).
const optionalDescription = (t: T) =>
  z
    .string()
    .optional()
    .refine(
      (value) =>
        !value || value.trim().length === 0 || value.trim().length >= 10,
      { message: t('descriptionMin') }
    )
    .refine((value) => !value || value.length <= 2000, {
      message: t('descriptionMax')
    });

export const createOcrTemplateSchema = (t: T) =>
  z.object({
    name: z
      .string()
      .min(3, t('nameMin'))
      .max(60, t('nameMax'))
      .regex(/^[A-Za-z؀-ۿ0-9\s_-]+$/, t('nameChars')),
    description: optionalDescription(t),
    dynamic_form_id: z.string().optional(),
    is_active: z.boolean().default(true),
    repeats_per_page: z.boolean().default(true),
    extract_undeclared_fields: z.boolean().default(false)
  });

export const updateOcrTemplateSchema = (t: T) =>
  z.object({
    name: z
      .string()
      .min(3, t('nameMin'))
      .max(60, t('nameMax'))
      .regex(/^[A-Za-z؀-ۿ0-9\s_-]+$/, t('nameChars')),
    description: optionalDescription(t),
    dynamic_form_id: z.string().optional(),
    is_active: z.boolean().default(true),
    repeats_per_page: z.boolean().default(true),
    extract_undeclared_fields: z.boolean().default(false)
  });

export type OcrTemplateFormValues = z.infer<
  ReturnType<typeof createOcrTemplateSchema>
>;
